import React from 'react';
import LoanSummarySC from './loan-summary.styled';
import { BodyText, SmallText, BiggerText, HeadingThree } from '../../typography';
import { ReactComponent as FinanceIcon } from '../../../assets/img/svg/finance.svg';
import { ReactComponent as GraphIcon } from '../../../assets/img/svg/graph-up.svg';
import { ReactComponent as SumIcon } from '../../../assets/img/svg/sum.svg';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';
import Moment from 'react-moment';

const LoanSummary = ({ investment }) => {
  return (
    <LoanSummarySC>
      <BodyText className="black-transparent bolder">
        <FormattedMessage
          id="investor_loan_detail_summary_headline"
          defaultMessage={dlt['investor_loan_detail_summary_headline']}
        />
      </BodyText>
      <div className="top-wrap">
        <div className="top-wrap--half-wrap">
          <div className="top-wrap--half-wrap__img-wrap">
            <FinanceIcon />
          </div>
          <div className="top-wrap--half-wrap__text-wrap">
            <SmallText className="black-transparent-lighter bolder">
              <FormattedMessage
                id="investor_loan_detail_summary_amount"
                defaultMessage={dlt['investor_loan_detail_summary_amount']}
              />
            </SmallText>
            <HeadingThree className="bold">
              {numeral(Number(investment.investor.amount)).format('0,00.00')} €
            </HeadingThree>
            <SmallText className="black-transparent-lighter bolder">
              <FormattedMessage
                id="investor_loan_detail_summary_remain"
                defaultMessage={dlt['investor_loan_detail_summary_remain']}
                values={{
                  value: numeral(Number(investment.investor.totalTillEnd[9])).format('0,00.00'),
                }}
              />
            </SmallText>
          </div>
        </div>
        <div className="top-wrap--half-wrap">
          <div className="top-wrap--half-wrap__img-wrap">
            <GraphIcon />
          </div>
          <div className="top-wrap--half-wrap__text-wrap">
            <SmallText className="black-transparent-lighter bolder">
              <FormattedMessage
                id="investor_loan_detail_summary_return"
                defaultMessage={dlt['investor_loan_detail_summary_return']}
              />
            </SmallText>
            <HeadingThree className="bold">
              {numeral(Number(investment.investor.totalTillEnd[4])).format('0,00.00')} €
            </HeadingThree>
          </div>
        </div>
        <div className="top-wrap--half-wrap">
          <div className="top-wrap--half-wrap__img-wrap">
            <SumIcon />
          </div>
          <div className="top-wrap--half-wrap__text-wrap">
            <SmallText className="black-transparent-lighter bolder">
              <FormattedMessage
                id="investor_loan_detail_summary_sum"
                defaultMessage={dlt['investor_loan_detail_summary_sum']}
              />
            </SmallText>
            <HeadingThree className="bold">
              {numeral(
                Number(investment.investor.amount) + Number(investment.investor.totalTillEnd[4])
              ).format('0,00.00')}
              €
            </HeadingThree>
          </div>
        </div>
      </div>

      <div className="bottom-wrap">
        <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_balance"
              defaultMessage={dlt['investor_loan_detail_summary_balance']}
            />
          </SmallText>
          <BiggerText>
            {numeral(Number(investment.investor.totalTillEnd[5])).format('0,00.00')} €
          </BiggerText>
        </div>
        <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_principal"
              defaultMessage={dlt['investor_loan_detail_summary_principal']}
            />
          </SmallText>
          <BiggerText>
            {numeral(Number(investment.investor.totalTillEnd[6])).format('0.[00]')} €
          </BiggerText>
        </div>
        <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_interest"
              defaultMessage={dlt['investor_loan_detail_summary_interest']}
            />
          </SmallText>
          <BiggerText className="green">
            {numeral(Number(investment.investor.totalTillEnd[7])).format('0.[00]')} €
          </BiggerText>
        </div>
        <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_repayment"
              defaultMessage={dlt['investor_loan_detail_summary_repayment']}
            />
          </SmallText>
          {investment.investor.schedules.length > 0 ? (
            <BiggerText>
              {numeral(Number(investment.investor.schedules[0][2])).format('0,00.00')} €
            </BiggerText>
          ) : (
            <BiggerText>-</BiggerText>
          )}
        </div>
        {/* <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_interest"
              defaultMessage={dlt['investor_loan_detail_summary_interest']}
            />
          </SmallText>
          <BiggerText>
            {numeral(Number(investment.investor.interestRate)).format('0.[00]')} % p.a.
          </BiggerText>
        </div>

        <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_last_payment"
              defaultMessage={dlt['investor_loan_detail_summary_last_payment']}
            />
          </SmallText>
          <BiggerText>
            {investment.status && investment.status.lastPaymentDate ? (
              <Moment parse="DD.MM.YYYY" format="DD. MMM YYYY">
                {investment.status.lastPaymentDate}
              </Moment>
            ) : (
              '-'
            )}
          </BiggerText>
        </div>
        </div> */}

        <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_last_payment"
              defaultMessage={dlt['investor_loan_detail_summary_last_payment']}
            />
          </SmallText>
          <BiggerText>
            {investment.status && investment.status.lastPaymentDate ? (
              <Moment parse="DD.MM.YYYY" format="DD. MMM YYYY">
                {investment.status.lastPaymentDate}
              </Moment>
            ) : (
              '-'
            )}
          </BiggerText>
        </div>

        {/* <div className="bottom-wrap--quarter">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_summary_end"
              defaultMessage={dlt['investor_loan_detail_summary_end']}
            />
          </SmallText>
          <BiggerText>
            {investment.investor.schedules.length > 0 ? (
              <Moment parse="DD.MM.YYYY" format="DD. MMM YYYY">
                {investment.investor.schedules[investment.investor.schedules.length - 1][1]}
              </Moment>
            ) : (
              '-'
            )}
          </BiggerText>
        </div> */}
      </div>
    </LoanSummarySC>
  );
};

export default LoanSummary;
